// Simplified toast implementation for demo purposes

type ToastVariant = "default" | "destructive";

export interface ToastProps {
  title?: string;
  description?: string;
  variant?: ToastVariant;
}

// Convenience method for direct toast calls
export const toast = (props: ToastProps) => {
  console.log(`Toast: ${props.variant || 'default'} - ${props.title} - ${props.description}`);
  // In a real app, this would use a global toast context
};

// Simple mock implementation
export function useToast() {
  return {
    toast,
  };
} 